<template>
  <div>
    <div class="answers-card row mb-1 justify-content-between">
      <b-form-input
        id="input-q"
        v-model="$v.questionObj.question.$model"
        :state="$v.questionObj.question.$dirty ? !$v.questionObj.question.$error : null"
        :disabled="isDisabled"
        size="sm"
        :placeholder="$t('pages.publish-offer.second-page.killer-questions.question.placeholder', 'Enter a question')"
        class="smaller-input"
        :class="[canSelectPredefined && !isDisabled ? 'col-7' : 'col-10']"
      />
      <b-button
        v-if="canSelectPredefined && !isDisabled"
        v-b-modal="'modal-select-predefined-' + number"
        size="sm"
      >
        {{ $t('pages.publish-offer.second-page.killer-questions.select-predefined', 'Select predefined question') }}
      </b-button>
      <b-button
        v-if="canDelete"
        variant="danger"
        size="sm"
        class="col-1"
        @click="$emit('removeQuestion', number)"
      >
        <font-awesome-icon
          icon="times"
        />
      </b-button>
    </div>
    <div class="answers-card row">
      <div class="col-3 labels">
        {{ $t('generic.answer', 'Answer {no}', { no: 1 }) }}:
      </div>
      <div class="col-6">
        <b-form-input
          id="input-a1"
          v-model="$v.questionObj.ans1.$model"
          :state="$v.questionObj.ans1.$dirty ? !$v.questionObj.ans1.$error : null"
          :disabled="isDisabled"
          size="sm"
          :placeholder="$t('pages.publish-offer.second-page.killer-questions.answer.placeholder', 'Enter an answer')"
          class="smaller-input"
        />
      </div>
      <div class="col-3">
        <b-form-select
          v-model="$v.questionObj.p1.$model"
          :state="isDisabled ? null : ($v.questionObj.p1.$dirty ? !$v.questionObj.p1 .$error : null)"
          :options="pointsOptions"
          :disabled="isDisabled"
          size="sm"
          class="smaller-input"
        />
      </div>

      <div class="col-3 labels">
        {{ $t('generic.answer', 'Answer {no}', { no: 2 }) }}:
      </div>
      <div class="col-6">
        <b-form-input
          id="input-a2"
          v-model="$v.questionObj.ans2.$model"
          :state="$v.questionObj.ans2.$dirty ? !$v.questionObj.ans2 .$error : null"
          :disabled="isDisabled"
          size="sm"
          :placeholder="$t('pages.publish-offer.second-page.killer-questions.answer.placeholder', 'Enter an answer')"
          class="smaller-input"
        />
      </div>
      <div class="col-3">
        <b-form-select
          v-model="$v.questionObj.p2.$model"
          :state="isDisabled ? null : ($v.questionObj.p2.$dirty ? !$v.questionObj.p2 .$error : null)"
          :options="pointsOptions"
          :disabled="isDisabled"
          size="sm"
          class="smaller-input"
        />
      </div>

      <div class="col-3 labels">
        {{ $t('generic.answer', 'Answer {no}', { no: 3 }) }}:
      </div>
      <div class="col-6">
        <b-form-input
          id="input-a3"
          v-model="questionObj.ans3"
          :disabled="isDisabled"
          size="sm"
          :placeholder="$t('pages.publish-offer.second-page.killer-questions.answer.placeholder', 'Enter an answer')"
          class="smaller-input"
        />
      </div>
      <div class="col-3">
        <b-form-select
          v-model="questionObj.p3"
          :options="pointsOptions"
          :disabled="isDisabled"
          size="sm"
          class="smaller-input"
        />
      </div>

      <div class="col-3 labels">
        {{ $t('generic.answer', 'Answer {no}', { no: 4 }) }}:
      </div>
      <div class="col-6">
        <b-form-input
          id="input-a4"
          v-model="questionObj.ans4"
          :disabled="isDisabled"
          size="sm"
          :placeholder="$t('pages.publish-offer.second-page.killer-questions.answer.placeholder', 'Enter an answer')"
          class="smaller-input"
        />
      </div>
      <div class="col-3">
        <b-form-select
          v-model="questionObj.p4"
          :options="pointsOptions"
          :disabled="isDisabled"
          size="sm"
          class="smaller-input"
        />
      </div>

      <div class="col-3 labels">
        {{ $t('generic.answer', 'Answer {no}', { no: 5 }) }}:
      </div>
      <div class="col-6">
        <b-form-input
          id="input-a5"
          v-model="questionObj.ans5"
          :disabled="isDisabled"
          size="sm"
          :placeholder="$t('pages.publish-offer.second-page.killer-questions.answer.placeholder', 'Enter an answer')"
          class="smaller-input"
        />
      </div>
      <div class="col-3">
        <b-form-select
          v-model="questionObj.p5"
          :options="pointsOptions"
          :disabled="isDisabled"
          size="sm"
          class="smaller-input"
        />
      </div>
    </div>

    <b-modal
      :id="'modal-select-predefined-' + number"
      :title="$t('pages.publish-offer.second-page.killer-questions.predefined-modal.title', 'Select predefined question')"
      :ok-title="$t('generic.select', 'Select')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      header-bg-variant="light"
      button-size="sm"
      @ok="selectPredefinedQuestion"
      @hidden="resetPredefinedSelectedQuestion"
    >
      <div class="mb-2">
        {{ $t('pages.publish-offer.second-page.killer-questions.predefined-modal.message') }}
      </div>
      <FoldersTree
        :folders-data="killerqFolders"
        :show-questions="true"
        :is-expanded="false"
        :is-folder-select="false"
        :is-question-select="true"
        :selected-question="selectedQuestion"
        :show-questions-count="true"
        @question-select="selectQuestion"
      />
    </b-modal>
  </div>
</template>

<script>
import FoldersTree from "@/components/jobs/killerQuestionsTemplates/FoldersTree";

import { required } from "vuelidate/lib/validators";

function initialData() {
  return {
    questionObj: {
      question: "",
      ans1: "",
      ans2: "",
      ans3: "",
      ans4: "",
      ans5: "",
      p1: "",
      p2: "",
      p3: "",
      p4: "",
      p5: ""
    },
    killerqFolders: [],
    selectedQuestion: {
      text: ""
    }
  }
}

export default {
  components: {
    FoldersTree
  },
  props: {
    number: {
      type: Number,
      default: 1
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    canSelectPredefined: {
      type: Boolean,
      default: false
    },
    questionTemplate: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return initialData();
  },
  computed: {
    pointsOptions() {
      return [
        { value: 20, text: this.$t('pages.publish-offer.second-page.killer-questions.accept', 'Accept') },
        { value: -1, text: this.$t('pages.publish-offer.second-page.killer-questions.discard', 'Discard') },
        { value: 0, text: '0' },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
      ];
    },
    isAdmin() {
      return this.$hasRole(['admin']);
    }
  },
  validations: {
    questionObj: {
      question: { required },
      ans1: { required },
      ans2: { required },
      p1: { required },
      p2: { required }
    }
  },
  watch: {
    questionObj: {
      handler(val) {
        if(!this.questionTemplate) {
          this.$emit('updateQuestion', this.number, val);
        }
      },
      deep: true
    },
    questionTemplate: {
      handler(val) {
        this.questionObj = initialData();
        this.questionObj.question = val.text;
        for(let index in val.killer_answers_templates) {
          let no = parseInt(index) + 1;
          this.questionObj['ans' + no] = val.killer_answers_templates[index].text;
          this.questionObj['p' + no] = val.killer_answers_templates[index].points;
        }
      }
    }
  },
  created() {
    if(!this.questionTemplate) {
      this.questionObj = {...this.question};
    }
    this.getPredefinedKillerQuestions();
  },
  methods: {
    validateAnswer() {
      this.$v.$touch()
      return !this.$v.$invalid;
    },
    getPredefinedKillerQuestions() {
      let url = this.isAdmin ? '/killer-questions-templates/all-admin'
          : '/killer-questions-templates/all-user-admin';

      this.axios.get(url)
        .then( response => {
          this.killerqFolders = response.data;
        });
    },
    selectQuestion(question) {
      if(question == this.selectedQuestion) {
        this.selectedQuestion = {
          text: ""
        };
      } else {
        this.selectedQuestion = question;
      }
    },
    selectPredefinedQuestion() {
      if(this.selectedQuestion.text != '') {
        this.questionObj.question = this.selectedQuestion.text;
      }
      for(let index in this.selectedQuestion.killer_answers_templates) {
        let number = parseInt(index) + 1;
        this.questionObj['ans' + number] = this.selectedQuestion.killer_answers_templates[index].text;
        this.questionObj['p' + number] = this.selectedQuestion.killer_answers_templates[index].points;
      }
    },
    resetPredefinedSelectedQuestion() {
      this.selectedQuestion = null;
      this.selectedQuestion = initialData().selectedQuestion;
    }
  }
}
</script>

<style lang="scss" scoped>
.answers-card {
  background: rgb(245, 245, 245);
  padding: 0.5rem 1rem;

  .labels {
    font-size: 0.75rem;
  }
}

.smaller-input {
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
</style>
